import React from 'react'
import { DateRangePicker } from 'rsuite'
import AppContext from '../../context/AppContext'
import { LOCAL_DAY_TH, DATE_PICKER_FORMAT } from '../../constants/date'
import moment from 'moment'

export default function DatePickerCustom({
  placeholder = DATE_PICKER_FORMAT,
  format = DATE_PICKER_FORMAT,
  locale = LOCAL_DAY_TH,
  startDate = null,
  endDate = null,
  ...props
}) {
  const contextValue = React.useContext(AppContext)

  // ## FORMAT :: allowedRange('2018-12-01', '2019-10-01') ##
  const { allowedRange, after, before } = DateRangePicker

  return (
    <DateRangePicker
      className={props.className}
      placeholder={DATE_PICKER_FORMAT}
      format={DATE_PICKER_FORMAT}
      locale={LOCAL_DAY_TH_FOR_DATERANGE}
      block
      oneTap
      value={[props.value || new Date(), props.value]}
      onChange={(value) => {
        props.onChange(value[0])
      }}
      disabled={props.disabled}
      ranges={[
        {
          label: 'วันนี้',
          value: [moment().startOf('day').toDate(), moment().startOf('day').toDate()],
        },
      ]}
      renderValue={(date, format) => <span>{date[0].toLocaleDateString('en-GB')}</span>}
      showOneCalendar
      // disabledDate={props.disabledDate}
      disabledDate={
        startDate && endDate
          ? allowedRange(startDate, endDate)
          : startDate
            ? before(startDate)
            : endDate
              ? after(endDate)
              : props.disabledDate || null
      }
      placement={props.placement}
    />
  )
}

const LOCAL_DAY_TH_FOR_DATERANGE = {
  sunday: 'อา',
  monday: 'จ',
  tuesday: 'อ',
  wednesday: 'พ',
  thursday: 'พฤ',
  friday: 'ศ',
  saturday: 'ส',
  ok: 'ตกลง',
  today: 'วันนี้',
  yesterday: 'เมื่อวานนี้',
  hours: 'ชั่วโมง',
  minutes: 'นาที',
  seconds: 'วินาที',
}
